import { CloseOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import Check from '@mui/icons-material/Check';
import { StepIconProps, styled, Switch } from '@mui/material';
import { saveAs } from 'file-saver';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Decommissionicon from '../assets/decomm_icon.png';
import LabelPrimary from '../assets/label_primary.svg';
import LedPrimary from '../assets/led_primary.svg';
import MiscPrimary from '../assets/misc_primary.svg';
import PolePrimary from '../assets/pole_primary.svg';
import { DecommissionObj } from '../interfaces/AddDecommission';
import AssetProps, { SectorObj } from '../interfaces/AssetProps';
import { ApiHandler } from '../services/apiHandler';
import { getOrganisationId, getRole, getTechType } from '../services/helper';
import './AssetDetailsPanel.css';
import ConfirmAlert from './confirmAlert';
import DecommissionAlert from './DecommissionAlert';
import DecommissionRequestAlert from './DecommissionRequestAlert';
import ErrorAlert from './ErrorAlert';
import LabelLessInput from './LabelLessInput';
import Modal from './Modal';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
import Spinner from './Spinner';
import SuccessAlert from './SuccessAlert';
import WarningAlert from './WarningAlert';
import { Divider, Tabs, TabsProps } from 'antd';
interface AssetDetailsPanelProps {
  assetDetails: AssetProps | undefined;
  goBack: any;
  setAction: any;
  rmaSerialNumber: any;
  getRFAnalysis: (latlng: string) => void;
  getBuildingPolygons: (lat: number, lng: number) => void;
}

const AssetDetailsPanel: React.FC<AssetDetailsPanelProps> = ({
  rmaSerialNumber,
  assetDetails,
  goBack,
  setAction,
  getRFAnalysis,
  getBuildingPolygons,
}) => {
  let navigate = useNavigate();
  const [replaceModal, showReplaceModal] = useState(false);
  const [decommissionVisible, setDecommissionConfirmVisible] = useState(false);
  const [DecommissionrequestVisible, setDecommissionRequestVisible] = useState(false);
  const [newSerialNumber, setNewSerialNumber] = useState<string[]>(new Array(assetDetails?.sectors.length).fill(''));
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [siteImages, setSiteImages] = useState<{ type: string; path: string }[]>([]);
  const [rfConfirmVisible, setRfConfirmVisible] = useState(false);
  const [error, setError] = useState({
    message: '',
    alert: false,
  });
  const [warning, setWarning] = useState({
    message: '',
    alert: false,
  });
  const [success, setSuccess] = useState({
    message: '',
    alert: false,
  });
  const [viewImage, setViewImage] = useState({
    image: '',
    fileName: '',
    popup: false,
  });
  const [rmaTabs, setRmaTabs] = useState<any>();
  const handleConfirmRFDetails = () => {
    setRfConfirmVisible(false);
    getRFDetails();
  };

  useEffect(() => {
    if (assetDetails?.asset?.images) {
      console.log('Asset Images:', assetDetails?.asset?.images);
      setSiteImages(assetDetails?.asset?.images);
    }
    if (assetDetails?.asset?.latitude && assetDetails?.asset?.longitude) {
      getBuildingPolygons(assetDetails?.asset?.latitude, assetDetails?.asset?.longitude);
    }
    // if (assetDetails?.sectors && assetDetails?.sectors.length > 0) {
    //   const rmaTabItems: TabsProps['items'] = [];

    //   for (let index = 0; index < assetDetails.sectors.length; index++) {
    //     const sector = assetDetails.sectors[index];

    //     rmaTabItems.push({
    //       key: `${index + 1}`,
    //       label: `sec ${index + 1}`,
    //       children: (

    //         </>
    //       ),
    //     });
    //   }

    //   setRmaTabs(rmaTabItems);
    // }
  }, [assetDetails]);

  const siteImageLabel: any = {
    FACELIFT: 'Face Lift',
  };

  const getImage = (image: string) => {
    setLoading(true);
    ApiHandler({ apiName: 'download', body: { path: image }, params: {} })
      .then((response: any) => {
        setViewImage({ image: response.data.file, fileName: image.slice(image.lastIndexOf('/') + 1), popup: true });
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };
  const decommissionAsset = (reasonBody: DecommissionObj) => {
    if (reasonBody.reason.trim() === '') {
      setWarning({ message: 'Decommission Reason category cannot be empty', alert: true });
      return;
    }
    setLoading(true);
    const requestBody: any = {
      tracking_id: assetDetails?.asset.tracking_id,
      reason: reasonBody.reason,
      comment: reasonBody.comment,
    };

    ApiHandler({ apiName: 'decomAsset', body: requestBody, params: {} })
      .then((response: any) => {
        setLoading(false);
        setDecommissionConfirmVisible(false);
        setDecommissionRequestVisible(true);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const downloadImage = () => {
    try {
      saveAs(viewImage.image, `${assetDetails?.asset.tracking_id}_${viewImage.fileName}`);
    } catch (error: any) {
      console.info(error);
    }
  };

  const replaceClicked = (e: any) => {
    console.log('New Serial Numbers:', newSerialNumber);
    if (newSerialNumber.some((serial) => serial.trim() === '')) {
      setWarning({ message: 'Serial number cannot be empty', alert: true });
      return;
    }
    rmaSerialNumber(newSerialNumber);
    setAction('rma');
    goBack('editAsset');
  };

  const initiatedecom = () => {
    let count: number = 0;
    assetDetails?.sectors.map((sector: SectorObj) => {
      if (sector.status === 'SAS' || sector.status === 'Submitted to AFC') {
        count++;
      }
    });
    if (assetDetails?.sectors.length === count) {
      setDecommissionConfirmVisible(true);
    } else {
      setWarning({ message: `${getTechType()} can only be decommissioned if all the sectors are in SAS.`, alert: true });
    }
  };

  const deleteAsset = () => {
    setDeleteConfirmVisible(false);
    setLoading(true);
    ApiHandler({ apiName: 'deleteAsset', body: {}, params: { tracking_id: assetDetails?.asset.tracking_id } })
      .then((response: any) => {
        setLoading(false);
        goBack('home');
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  const editClicked = () => {
    setAction('edit');
    goBack('editAsset');
  };

  const initiateRma = () => {
    let count: number = 0;
    assetDetails?.sectors.map((sector: SectorObj) => {
      if (sector.status === 'SAS' || sector.status === 'Submitted to AFC') {
        count++;
      }
    });
    if (assetDetails?.sectors.length === count) {
      showReplaceModal(true);
    } else {
      setWarning({ message: 'Base Station can only be replaced if all the sectors are in SAS.', alert: true });
    }
  };

  const imageTypes: any = {
    led: LedPrimary,
    pole: PolePrimary,
    label: LabelPrimary,
    misc: MiscPrimary,
  };

  const getDeviceTitle: any = {
    cbrs_5g: 'Base Station',
    wifi_6e: 'Wi-Fi',
    cpe_cbsd: 'CPE',
    cpe_wifi: 'CPE',
    '': 'Asset',
    '5g': '5G',
    tarana: 'Base Node',
    tarana_cpe: 'Remote Node',
  };

  // const steps = ['SAS Registration Pending', 'NE Created in USM', 'Grant Acquired', 'Registered', 'Authorized', 'On Air'];

  const getRFDetails = () => {
    getRFAnalysis(assetDetails?.asset?.tracking_id as string);
  };

  return (
    <div className="app-card position-relative app-card-size overflow-auto">
      {/* <div className="row-wise vertical-center">
        <div
          className="icon-background-active"
          onClick={() => {
            goBack('home');
          }}>
          <span className="material-icons-round icon-active">arrow_back</span>
        </div>
        <span className="app-card-action-heading ms-3">{`${getDeviceTitle[assetDetails?.asset?.technology_type ?? '']} Details`}</span>
      </div> */}
      <div className="row-wise vertical-center space-between px-4 py-3">
        <span className="app-card-action-heading fw-bold"> {`${getDeviceTitle[assetDetails?.asset?.technology_type ?? '']} Details`}</span>{' '}
        {/* //ADDING CBSD */}
        <div
          // className="icon-background-active"
          onClick={() => {
            goBack('home');
          }}>
          <CloseOutlined className="fs-6" />
        </div>
      </div>
      <div className="vertical-center space-between me-4">
        <span className="asset-name px-4">{assetDetails?.asset?.cbrs_node_name ? assetDetails?.asset?.cbrs_node_name : '-'}</span>
        {/* <span onClick={() => setRfConfirmVisible(true)} className="rf-btn">
          RF Design Analysis
        </span> */}
      </div>
      <span className="asset-description mt-2 px-4">{assetDetails?.asset?.description ? assetDetails?.asset?.description : ''}</span>
      <div className="border-bottom" />

      {assetDetails?.asset?.deployment_location === 'indoor' ? (
        <div className="px-4 py-3">
          <div className="col-wise w-100 indoor-details px-2">
            <span className="indoor-heading mb-2">Venue Details</span>
            {assetDetails?.asset?.venue_name && (
              <span className="indoor-sub-heading mb-1">
                Venue: <span className="indoor-value">{assetDetails?.asset?.venue_name}</span>
              </span>
            )}
            {assetDetails?.asset?.building_name && (
              <span className="indoor-sub-heading mb-1">
                Building: <span className="indoor-value">{assetDetails?.asset?.building_name}</span>
              </span>
            )}
            {assetDetails?.asset?.floor_number && (
              <span className="indoor-sub-heading">
                Floor: <span className="indoor-value">{assetDetails?.asset?.floor_number}</span>
              </span>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}

      <div className="overflow-auto h-100 px-4 py-3">
        <div className="row g-0">
          <div className="col col-wise">
            <span className="value-title">{getOrganisationId() !== 1 || assetDetails?.vendor?.vendor_type !== 'Nokia' ? 'Asset ID:' : 'UID:'}</span>
            <span className="value-label mt-1">{assetDetails?.asset?.tracking_id ? assetDetails?.asset?.tracking_id : '-'}</span>
          </div>
          <div className="col col-wise">
            <span className="value-title">Site ID:</span>
            <span className="value-label mt-1">{assetDetails?.asset?.site_id ? assetDetails?.asset?.site_id : '-'}</span>
          </div>
        </div>

        <div className="row g-0">
          <div className="col col-wise">
            <span className="value-title mt-3">Latitude:</span>
            <span className="value-label mt-1">{assetDetails?.asset?.latitude ? assetDetails?.asset?.latitude?.toFixed(6) : '-'}</span>
          </div>
          <div className="col d-flex flex-row justify-content-between align-items-end">
            <div className="col-wise">
              <span className="value-title mt-3">Longitude:</span>
              <span className="value-label mt-1">{assetDetails?.asset?.longitude ? assetDetails?.asset?.longitude?.toFixed(6) : '-'}</span>
            </div>
            <span
              style={{ color: '#8F9FAC', cursor: 'pointer', userSelect: 'none' }}
              className="material-icons-round"
              onClick={() => {
                navigator.clipboard.writeText(`${assetDetails?.asset?.latitude}, ${assetDetails?.asset?.longitude}`);
                setSuccess({ message: 'Copied to clipboard', alert: true });
              }}>
              content_copy
            </span>
          </div>
        </div>

        <div className="row g-0">
          <div className="col col-wise">
            <span className="value-title mt-3">Height:</span>
            <span className="value-label mt-1">{assetDetails?.asset?.height ? assetDetails?.asset?.height : '-'} ft</span>
          </div>
          {assetDetails?.asset?.technology_type === 'cbrs_5g' ? (
            <div className="col col-wise">
              <span className="value-title mt-3">gNB ID:</span>
              <span className="value-label mt-1">{assetDetails?.asset?.gnodeb_id ? assetDetails?.asset?.gnodeb_id : '-'}</span>
            </div>
          ) : null}
        </div>

        {assetDetails?.asset?.technology_type === 'cbrs_5g' && (
          <div className="row g-0">
            <div className="col col-wise">
              <span className="value-title mt-3">Mounting Type:</span>
              <span className="value-label mt-1">{assetDetails?.asset?.mounting_type ? assetDetails?.asset?.mounting_type : '-'}</span>
            </div>
          </div>
        )}

        <div className="row g-0">
          <div className="col col-wise">
            <span className="value-title mt-3">Device MAC:</span>
            <span className="value-label mt-1">{assetDetails?.asset?.device_mac ? assetDetails?.asset?.device_mac : '-'}</span>
          </div>
          {assetDetails?.vendor?.has_cable_modem && (
            <div className="col col-wise">
              <span className="value-title mt-3">Device p/N :</span>
              <span className="value-label mt-1">{assetDetails?.asset?.device_pn ? assetDetails?.asset?.device_pn : '-'}</span>
            </div>
          )}
        </div>
        {assetDetails?.vendor?.has_cable_modem && (
          <div className="row g-0">
            <div className="col col-wise">
              <span className="value-title mt-3">Docsis Serial #:</span>
              <span className="value-label mt-1">{assetDetails?.asset?.cm_serial_number ? assetDetails?.asset?.cm_serial_number : '-'}</span>
            </div>
            <div className="col col-wise">
              <span className="value-title mt-3">Docsis MAC :</span>
              <span className="value-label mt-1">{assetDetails?.asset?.cm_mac ? assetDetails?.asset?.cm_mac : '-'}</span>
            </div>
          </div>
        )}

        <div className="row g-0">
          {assetDetails?.vendor?.has_cable_modem && (
            <div className="col col-wise">
              <span className="value-title mt-3">Docsis P/N #:</span>
              <span className="value-label mt-1">{assetDetails?.asset?.cm_pn ? assetDetails?.asset?.cm_pn : '-'}</span>
            </div>
          )}
        </div>

        {siteImages?.filter((image: any) =>
          ['MISCELLANEOUS_1', 'MISCELLANEOUS_2', 'MISCELLANEOUS_3', 'MISCELLANEOUS_4', 'FACELIFT'].includes(image?.type)
        )?.length ? (
          <div className="my-3">
            <span className="image-title">Other Images</span>
            <div className="d-flex flex-row flex-wrap gap-2 mt-2">
              {siteImages
                ?.filter((image: any) =>
                  ['MISCELLANEOUS_1', 'MISCELLANEOUS_2', 'MISCELLANEOUS_3', 'MISCELLANEOUS_4', 'FACELIFT'].includes(image?.type)
                )
                ?.map((image: any, index) => {
                  return (
                    <div
                      key={image.type + 'image.path' + index}
                      className="d-flex flex-column gap-1 "
                      onClick={() => {
                        getImage(image.path);
                      }}>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ background: '#F5F5F5', borderRadius: '8px', color: '#8F9FAC', cursor: 'pointer' }}>
                        <span className="material-icons-round" style={{ fontSize: '35px' }}>
                          image
                        </span>
                      </div>
                      <span className="image-list-label">{siteImageLabel[image?.type]}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        ) : (
          ''
        )}

        {/* <label className="image-title mt-3">Status</label> */}

        {/* <Steps
          className="mt-2"
          size="small"
          progressDot
          current={getProgress()}
          direction="vertical"
          items={[
            {
              title: 'SAS Registration Pending',
            },
            {
              title: 'NE Created in USM',
            },
            {
              title: 'Grant Acquired',
            },
            {
              title: 'Registered',
            },
            {
              title: 'Authorized',
            },
            {
              title: 'On Air',
            },
          ]}
        /> */}

        {siteImages?.filter((image: any) => ['DECOMM_RADIO_LABEL', 'DECOMM_MISCELLANEOUS', 'SITE_DECOMM_SUCCESS'].includes(image?.type))?.length ? (
          <div className="mt-3">
            <span className="image-title">Decommission Images</span>
            <div className="d-flex flex-row flex-wrap gap-2 mt-2">
              {siteImages
                ?.filter((image: any) => ['DECOMM_RADIO_LABEL', 'DECOMM_MISCELLANEOUS', 'SITE_DECOMM_SUCCESS'].includes(image?.type))
                ?.map((image: any) => {
                  return (
                    <div
                      key={image.type}
                      className="d-flex flex-column image-box-site gap-1"
                      onClick={() => {
                        getImage(image.path);
                      }}>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ background: '#F5F5F5', borderRadius: '8px', color: '#8F9FAC', height: '80px', cursor: 'pointer' }}>
                        <span className="material-icons-round">image</span>
                      </div>
                      <span className="image-list-label">{siteImageLabel[image?.type]}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        ) : (
          ''
        )}
        {/*} {assetDetails?.base_node_connections && assetDetails.base_node_connections.length > 0 && (
          <>
            <Divider />
            <div className="d-flex align-items-center">
              <label>View RF path analysis </label>
              <Switch size="small" className="ms-4" checked={viewRFPathAnalysis} onChange={(e) => setViewRFPathAnalysis(e.target.checked)} />
            </div>
          </>
        )} */}
      </div>

      {!['Physically Decommissioned', 'Decommission Requested', 'Decommissioned'].includes(assetDetails?.asset.status ?? '') ? (
        <div className="h-auto mt-2 col-wise justify-content-end px-4 py-3">
          <div className="row g-0 mb-2">
            <div className="col">
              <SecondaryButton
                icon={<img src={Decommissionicon} alt="delete-icon" style={{ paddingBottom: '5px', width: '16px', height: '20px' }} />}
                clicked={initiatedecom}
                label="Decommission"
              />
            </div>
            <div className="col ms-2">
              <SecondaryButton icon="sync_alt" clicked={initiateRma} label="RMA" />
            </div>
          </div>
          <div className="row g-0">
            <div className="col">
              <SecondaryButton
                disable={['installer', 'engineer'].includes(getRole()?.toLowerCase())}
                icon={<DeleteOutlined />}
                type="delete"
                clicked={() => {
                  setDeleteConfirmVisible(true);
                }}
                label="Delete"
              />
            </div>
            <div className="col ms-2">
              <SecondaryButton icon={<EditOutlined />} clicked={editClicked} label="Edit" />
            </div>
          </div>
        </div>
      ) : (
        <>
          {['Physically Decommissioned', 'Decommissioned'].includes(assetDetails?.asset.status ?? '') ? (
            <div className="h-auto mt-2 col-wise justify-content-end px-4 py-3">
              <div className="col">
                <SecondaryButton
                  icon="delete"
                  type="delete"
                  clicked={() => {
                    setDeleteConfirmVisible(true);
                  }}
                  label="Delete"
                />
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      )}

      <Modal show={replaceModal}>
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content app-card border-0 p-0">
            <div className="modal-header">
              <h5 className="modal-title">{`Replace ${getTechType()}`}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={(e: any) => {
                  e.preventDefault();
                  showReplaceModal(false);
                }}></button>
            </div>
            <Tabs className="px-4" defaultActiveKey="1">
              {assetDetails?.sectors &&
                assetDetails?.sectors.length > 0 &&
                assetDetails?.sectors.map((sector: SectorObj, index: number) => {
                  return (
                    <Tabs.TabPane tab={`Sector ${index + 1}`} key={`${index + 1}`}>
                      <span className="app-card-action-heading ms-2 mb-2" style={{ textTransform: 'none' }}>
                        Old Serial Number
                      </span>

                      <LabelLessInput className="mt-2 mb-4" placeholder="Old Serial Number" value={sector.serial_number ?? ''} disabled w100 />

                      <span className="app-card-action-heading ms-2" style={{ textTransform: 'none' }}>
                        New Serial Number
                      </span>
                      <LabelLessInput
                        className="mt-2"
                        placeholder="New Serial Number"
                        value={newSerialNumber[index]}
                        changeVal={(e: any) => {
                          const updatedSerialNumbers = [...newSerialNumber];
                          updatedSerialNumbers[index] = e.target.value;
                          setNewSerialNumber(updatedSerialNumbers);
                        }}
                        w100
                      />
                    </Tabs.TabPane>
                  );
                })}
            </Tabs>
            {/* <div className="modal-body px-4">               */}

            <div className="modal-footer mt-2">
              <PrimaryButton
                label={'Replace'}
                clicked={(e: any) => {
                  replaceClicked(e);
                }}
                className="w-100"
              />
            </div>
          </div>
        </div>
      </Modal>

      <Modal show={viewImage.popup}>
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content app-card border-0 p-0">
            <div className="modal-header">
              <h5 className="modal-title">{'Site Image'}</h5>
              <div className="row-wise download-box ms-2" onClick={downloadImage}>
                <span className="material-icons-round me-1 download-icon">file_download</span>
                <span className="download-label">DOWNLOAD</span>
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={(e: any) => {
                  e.preventDefault();
                  setViewImage({ image: '', fileName: '', popup: false });
                }}></button>
            </div>
            <div className="modal-body p-0 overflow-hidden">
              <img
                loading="eager"
                onLoad={() => {
                  setLoading(false);
                }}
                className="w-100"
                src={viewImage.image}
              />
            </div>
          </div>
        </div>
      </Modal>

      <ErrorAlert
        show={error.alert}
        onDismiss={() => {
          setError({ message: '', alert: false });
        }}
        message={error.message}
      />
      <SuccessAlert
        show={success.alert}
        onDismiss={() => {
          setSuccess({ message: '', alert: false });
        }}
        message={success.message}
      />
      <WarningAlert
        show={warning.alert}
        onDismiss={() => {
          setWarning({ message: '', alert: false });
        }}
        message={warning.message}
      />
      <Spinner show={loading} />
      <ConfirmAlert
        title={`Delete ${getDeviceTitle[assetDetails?.asset?.technology_type ?? '']}`}
        message={`Are you sure you want to delete ${getDeviceTitle[assetDetails?.asset?.technology_type ?? '']}?`}
        note={`${getOrganisationId() !== 1 || assetDetails?.vendor?.vendor_type !== 'Nokia' ? 'Asset ID:' : 'UID:'} ${
          assetDetails?.asset.tracking_id
        }`}
        primaryText="Confirm"
        secondaryText="Cancel"
        secondaryAction={() => {
          setDeleteConfirmVisible(false);
        }}
        primaryAction={() => {
          deleteAsset();
        }}
        visible={deleteConfirmVisible}
        onClose={() => {
          setDeleteConfirmVisible(false);
        }}
      />
      <ConfirmAlert
        title="DESIGN A JOB"
        message="Do you want to initiate RF design and create a job?"
        note=""
        primaryText="Confirm"
        secondaryText="Cancel"
        visible={rfConfirmVisible}
        onClose={() => setRfConfirmVisible(false)}
        secondaryAction={() => setRfConfirmVisible(false)}
        primaryAction={handleConfirmRFDetails}
      />
      <DecommissionAlert
        visible={decommissionVisible}
        title={`DECOMMISSION`}
        tracking_id={`${assetDetails?.asset.tracking_id}`}
        vendorType={`${assetDetails?.vendor?.vendor_type}`}
        primaryText="Request Decommission"
        secondaryText="Cancel"
        secondaryAction={() => {
          setDecommissionConfirmVisible(false);
        }}
        primaryAction={(obj: DecommissionObj) => {
          decommissionAsset(obj);
        }}
      />
      <DecommissionRequestAlert
        visible={DecommissionrequestVisible}
        title={'DECOMMISSION REQUEST SUCCESSFULL'}
        sub_title={`${assetDetails?.asset.cbrs_node_name} device decommission request is successfull`}
        primaryText="Close"
        primaryAction={() => {
          setDecommissionRequestVisible(false);
          goBack('home');
        }}
      />
    </div>
  );
};

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(({ theme }) => ({
  color: '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  '& .QontoStepIcon-completedIcon': {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  ...theme.applyStyles('dark', {
    color: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }: any) => ownerState.active,
      style: {
        color: '#784af4',
      },
    },
  ],
}));

function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? <Check className="QontoStepIcon-completedIcon" /> : <div className="QontoStepIcon-circle" />}
    </QontoStepIconRoot>
  );
}

export default AssetDetailsPanel;
